const COLORS = ["bg-violet-100 text-violet-800", "bg-sky-100 text-sky-800", "bg-emerald-100 text-emerald-800", "bg-amber-100 text-amber-800", "bg-rose-100 text-rose-800", "bg-slate-200 text-slate-800"];
export const speakerColor = (n) => COLORS[(Number(n) - 1) % COLORS.length];

import { fmtTime } from "@/lib/api";

export const segText = (s, version) => {
  if (version === "raw") return s.raw || s.text;
  if (["ms", "en", "id"].includes(version)) return s.translations?.[version] || s.text;
  return s.text;
};

export const groupParagraphs = (segs, sections = [], maxSec = 90) => {
  const titles = Object.fromEntries(sections.map((x) => [x.idx, x]));
  const out = [];
  segs.forEach((s, i) => {
    const idx = s.idx ?? i;
    if (titles[idx]) out.push({ section: titles[idx] });
    const last = out[out.length - 1];
    if (last && !last.section && last.speaker === s.speaker && s.start - last.start < maxSec) last.segs.push(s);
    else out.push({ speaker: s.speaker, start: s.start, segs: [s] });
  });
  return out;
};

export const activeWord = (s, version, current, words) => {
  if (current < s.start || current >= s.end) return -1;
  if (version === "raw" && s.words?.length) {
    let k = -1;
    s.words.forEach((w, i) => { if (w[0] <= current) k = i; });
    return k;
  }
  return Math.min(words.length - 1, Math.floor(((current - s.start) / Math.max(0.1, s.end - s.start)) * words.length));
};

export const plainText = (segs, sections, names, { version, timestamps, speakers }) =>
  groupParagraphs(segs, sections)
    .map((b) => {
      if (b.section) return `\n## ${b.section.title}`;
      const head = [speakers && (names[String(b.speaker)] || `Pembicara ${b.speaker}`), timestamps && fmtTime(b.start)].filter(Boolean).join(" · ");
      return `${head ? `[${head}]\n` : ""}${b.segs.map((s) => segText(s, version)).join(" ")}\n`;
    })
    .join("\n")
    .trim();

export const wordCount = (segs) => segs.reduce((n, s) => n + s.text.split(/\s+/).filter(Boolean).length, 0);
